/* Alfrea cart drawer — the only behaviour Dawn does not already provide.

   Everything else is Dawn's: cart-drawer.js opens and closes the drawer,
   cart.js drives quantity and remove, product-form.js posts the upsell and
   asks for a re-render. This file adds one custom element and nothing more.

   The countdown re-registers itself after every cart render because the
   drawer's innerHTML is replaced wholesale — a custom element handles that
   for free via connectedCallback, which is why this is an element rather
   than a querySelector loop.
*/
(function () {
  if (customElements.get('alfrea-cart-timer')) return;

  customElements.define(
    'alfrea-cart-timer',
    class AlfreaCartTimer extends HTMLElement {
      connectedCallback() {
        const seconds = parseInt(this.dataset.duration, 10);
        if (!seconds || seconds < 1) return;

        // Anchor to a timestamp in sessionStorage so a cart re-render, or
        // moving between pages, resumes the same countdown instead of
        // restarting it — the drawer is rebuilt on every quantity change.
        const KEY = 'alfrea-cart-timer-ends';
        let endsAt = parseInt(sessionStorage.getItem(KEY), 10);
        if (!endsAt || endsAt < Date.now()) {
          endsAt = Date.now() + seconds * 1000;
          sessionStorage.setItem(KEY, String(endsAt));
        }

        const tick = () => {
          const left = Math.max(0, Math.round((endsAt - Date.now()) / 1000));
          const m = String(Math.floor(left / 60)).padStart(2, '0');
          const s = String(left % 60).padStart(2, '0');
          this.textContent = m + ':' + s;
          if (left <= 0) this.stop();
        };

        tick();
        this.interval = setInterval(tick, 1000);
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        if (this.interval) clearInterval(this.interval);
        this.interval = null;
      }
    }
  );
})();
